/*
 * @Author: Wang Bingjing
 * @Date: 2021-02-22 15:27:48
 * @LastEditTime: 2021-05-18 14:09:05
 * @LastEditors: Wang Bingjing
 */
import axios from 'axios'

import { getToken } from '../common/session'

const defaultHeaders = {
	'Content-Type': 'application/json',
	'Origin-Type': 'front',
	'token': '',
}

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
	response => {
		if (response.status >= 200 && response.status < 300 && response.config.responseType === 'blob') {
			console.log(response.config.responseType)
			var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
			var downloadElement = document.createElement('a');
			var href = window.URL.createObjectURL(blob);
			downloadElement.href = href;
			downloadElement.download = decodeURI(response.headers['content-disposition']?.match(
				/filename\*=UTF-8''(.*)/
			)[1]);
			document.body?.appendChild(downloadElement);
			downloadElement.click();
			document.body.removeChild(downloadElement);
			window.URL.revokeObjectURL(href);
			return response.data
		} else {
			return response.data
		}
	},
	error => {
		console.log(error)
		return Promise.reject(error)
	})


export function getApi(url, headers = defaultHeaders, responseType = 'json') {
	return axios({ method: 'get', url, headers, responseType })
}

export function postApi(url, data, headers = defaultHeaders) {
	return axios({
		method: 'post', url, headers, data,
	})
}

export function putApi(url, body, headers = defaultHeaders) {
	return axios({
		method: 'put', url, headers, body,
	})
}

export function deleteApi(url, data = {}, headers = defaultHeaders) {
	return axios({
		method: 'delete', url, headers, data,
	})
}
